/**
 * Optimistic `isShared` after a revoke save.
 * `remainingAccesses` is already original minus revoked (see FileShareForm currentAccessesForPayload).
 * Same save can also add recipients — those keep the file shared.
 */
export function isSharedAfterAccessRevoke(
  remainingAccessesLength: number,
  newUserCount: number,
  newGroupCount: number,
): boolean {
  return remainingAccessesLength > 0 || newUserCount > 0 || newGroupCount > 0;
}
